import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

import { getCommentList } from '../../../api/comments';

import { generateItemCIDKey } from '../../../components/Items/utils/generateItemCIDKey';
import { generateCommentCIDKey } from '../../../components/Comments/utils/generateCommentCIDKey';
import { mergeCommentListWithUserData } from '../../../utils/comments';
import {
  checkAndSetLoadingWithId,
  handleRequestRejection,
  onMatchedRequest,
} from '../../../utils/asyncThunkRequest';

export const fetchPinnedComments = createAsyncThunk(
  'comments/fetchPinnedComments',
  async (commentsData, { signal, rejectWithValue }) => {
    const source = axios.CancelToken.source();
    signal.addEventListener('abort', () => {
      source.cancel();
    });
    try {
      const [commentsResponse, userDataMapResponse] = await getCommentList(
        {
          ...commentsData,
          params: {
            ...commentsData.params,
            pinned: true,
          },
        },
        {
          cancelToken: source.token,
        },
      );
      return {
        data: mergeCommentListWithUserData(
          commentsResponse,
          userDataMapResponse,
        ),
      };
    } catch (error) {
      return rejectWithValue(error.response);
    }
  },
);

export const fetchPinnedCommentsExtraReducers = builder => {
  builder
    .addCase(fetchPinnedComments.pending, (state, action) => {
      const parentCIDKey = generateItemCIDKey({
        ...action.meta.arg.path,
        commentId: action.meta.arg.params.commentId,
      });

      checkAndSetLoadingWithId(
        state.comments.pinnedComments.request,
        action,
        parentCIDKey,
      );
    })
    .addCase(fetchPinnedComments.fulfilled, (state, action) => {
      const parentCIDKey = generateItemCIDKey(action.meta.arg.path);

      onMatchedRequest(
        state.comments.pinnedComments.request[parentCIDKey],
        action,
        () => {
          action.payload.data.comments.forEach(comment => {
            const commentCIDKey = generateCommentCIDKey(comment);
            state.comments.comment.byId[commentCIDKey] = comment;
            if (!state.comments.comment.allIds.includes(commentCIDKey)) {
              state.comments.comment.allIds.push(commentCIDKey);
            }
            if (!state.comments.item.byId[parentCIDKey]) {
              state.comments.item.byId[parentCIDKey] = [];
            }
            if (
              !state.comments.item.byId[parentCIDKey].includes(commentCIDKey)
            ) {
              state.comments.item.byId[parentCIDKey].unshift(commentCIDKey);
            }
            if (
              !state.comments.parent.byId[commentCIDKey] &&
              comment.metadata.replies > 0
            ) {
              state.comments.parent.byId[commentCIDKey] = [];
            }
          });
        },
      );
    })
    .addCase(fetchPinnedComments.rejected, (state, action) => {
      const parentCIDKey = generateItemCIDKey(action.meta.arg.path);

      handleRequestRejection(
        state.comments.pinnedComments.request[parentCIDKey],
        action,
      );
    });
};
